module.exports = __webpack_public_path__ + "static/media/smui.c10284c5.png";